import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProfileRest } from './profile-rest.service';
import {PortalUserProfileView} from '../../../models/generated-models';

export const viewProfileResolver: ResolveFn<PortalUserProfileView> = () => {
    return inject(ProfileRest).getUserProfile();
};
